// "use strict";
import { OLabApiQuestion } from "./OLabApiQuestion";

export class OLabApiDropdownQuestion extends OLabApiQuestion {
  constructor(clientApi, id) {
    super(clientApi, id);
  }
}
